var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridWaveBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 400",
    width: "100%",
    height: 400,
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40",
    fill: "none",
    stroke: "rgba(255,255,255,.08)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent,#37E5FF)",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-primary,#7C4DFF)",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("style", null, "\n      .grid { fill: url(#grid) }\n      .wave { fill: url(#glow); transform: translateX(-10%); animation: drift 20s linear infinite; }\n      @keyframes drift { to { transform: translateX(10%); } }\n      @media (prefers-reduced-motion: reduce) { .wave { animation: none } }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 400,
    className: "grid"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wave",
    d: "M0,280 C200,240 400,320 600,280 C800,240 1000,320 1200,280 L1200,400 H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridWaveBg);
export default __webpack_public_path__ + "static/media/grid-wave-bg.e3bf64671438e56bbfaa3bd4853c581d.svg";
export { ForwardRef as ReactComponent };